import React, { useEffect, useRef } from 'react';
import { View, Animated, StyleSheet } from 'react-native';

const SkeletonItem = ({ width, height, borderRadius = 8, style }: any) => {
  const shimmerAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(shimmerAnim, {
        toValue: 1,
        duration: 1200,
        useNativeDriver: true,
      })
    ).start();
  }, []);

  const translateX = shimmerAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [-200, 200],
  });

  return (
    <View
      style={[
        {
          width,
          height,
          backgroundColor: '#EAECF0',
          overflow: 'hidden',
          borderRadius,
        },
        style,
      ]}
    >
      <Animated.View
        style={[
          StyleSheet.absoluteFill,
          {
            transform: [{ translateX }],
            backgroundColor: '#F2F4F7',
            opacity: 0.7,
          },
        ]}
      />
    </View>
  );
};

const RentReviewSkeleton = () => {
  return (
    <View style={styles.cardContainer}>
      {/* Header Skeleton */}
      <View style={styles.headerRow}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <SkeletonItem width={36} height={36} borderRadius={18} style={{ marginRight: 12 }} />
          <SkeletonItem width={180} height={24} borderRadius={6} />
        </View>
        <SkeletonItem width={32} height={32} borderRadius={16} />
      </View>

      {/* Subtitle Skeleton */}
      <SkeletonItem width={240} height={16} borderRadius={4} style={{ marginBottom: 24 }} />

      {/* Rent Section Skeleton */}
      <View style={{ marginBottom: 24 }}>
        <SkeletonItem width={90} height={18} borderRadius={4} style={{ marginBottom: 8 }} />
        <SkeletonItem width={140} height={32} borderRadius={6} />
      </View>

      {/* Document Cards Skeleton */}
      <View style={{ marginBottom: 20 }}>
        <SkeletonItem width="100%" height={72} borderRadius={14} style={{ marginBottom: 12 }} />
        <SkeletonItem width="100%" height={72} borderRadius={14} style={{ marginBottom: 12 }} />
      </View>

      {/* Status Badge Skeleton */}
      <View style={{ alignItems: 'center', marginBottom: 24 }}>
        <SkeletonItem width={130} height={28} borderRadius={8} />
      </View>

      {/* Buttons Skeleton */}
      <View style={{ flexDirection: 'row' }}>
        <SkeletonItem width="48%" height={48} borderRadius={1000} style={{ marginRight: '4%' }} />
        <SkeletonItem width="48%" height={48} borderRadius={1000} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cardContainer: {
    width: '100%',
    maxWidth: 620,
    borderRadius: 20,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingVertical: 24,
    shadowColor: '#101828',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
    elevation: 4,
    borderWidth: 1,
    borderColor: '#E4E7EC',
    alignSelf: 'center',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
});

export default RentReviewSkeleton;
